/**
 * Notification Bar constants
 *
 */

export const AUTO_CLOSE_TIMEOUT = 10000;
